import { render, staticRenderFns } from "./GitHub.vue?vue&type=template&id=4a26def8&scoped=true"
var script = {}
import style0 from "./GitHub.vue?vue&type=style&index=0&id=4a26def8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a26def8",
  null
  
)

export default component.exports